import PropTypes from "prop-types";
import React, { Component } from 'react';
import moment from 'moment';
import { DatePicker } from 'antd';

class Calendar extends Component {
  state = {
    calendarState: false
  };

  calendarInputRef = React.createRef(); 

  componentDidUpdate() {
    setTimeout(() => {
      const calendarId = this.props.id ? this.props.id: 'customDatePicker';      
      let calendarInputEle = document.querySelector(`#${calendarId} .ant-calendar-input`);
      let calBindIinputEle = document.querySelector(`#${calendarId} .ant-calendar-picker-input`);
      if (calendarInputEle) {
        calendarInputEle.addEventListener(
          'keydown',
          this.checkInvalidDate,
          false
        );     
      }

      if(calBindIinputEle) {
        calBindIinputEle.addEventListener(
          'focus',
          this.handleFocus,
          false
        );
      }
    }, 0);
  }

  handleFocus = (event) => {    
    this.handleDatePicker(!this.state.calendarState);
  }

  checkInvalidDate = event => {    
    if(event.keyCode === 13) {      
      let date = moment(event.target.value);
      let date_regex = /^\d{2}\/\d{2}\/\d{4}$/;
      if (!date.isValid() || !date_regex.test(event.target.value)) {        
        event.stopPropagation(); 
        this.props.onChange('');        
        if(this.calendarInputRef.current) this.calendarInputRef.current.focus();
      }
    }
  };

  handleDatePicker = open => {
    this.setState({
      calendarState: open
    });
  };

  render() {
    const calendarId = this.props.id ? this.props.id: 'customDatePicker';
    return (
      <DatePicker
      data-test="date-picker"
        aria-label={this.props.ariaLabel}
        id= { calendarId }
        className={ this.props.className ? this.props.className: '' }
        ref={this.calendarInputRef}
        getCalendarContainer={() => document.getElementById(calendarId)}
        open={this.state.calendarState}
        value={this.props.value && moment(this.props.value)}
        readOnly={this.props.readOnly}
        format={this.props.format}
        disabledDate={this.props.disabledDate}
        placeholder={this.props.placeHolder}
        allowClear={this.props.allowClear}
        onOpenChange={this.handleDatePicker}
        onBlur={e => (this.props.onBlur ? this.props.onBlur(e) : () => null)}
        onChange={date =>
          this.props.onChange ? this.props.onChange(date) : () => null
        }
      />
    );
  }
}

Calendar.propTypes = {
  allowClear: PropTypes.any,
  disabledDate: PropTypes.any,
  format: PropTypes.any,
  id: PropTypes.any,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  placeHolder: PropTypes.string,
  readOnly: PropTypes.any,
  value: PropTypes.func
}

export default Calendar;
